// Model images
import kofi_a_headshot from "../../../assets/kofi_a_headshot.png";
import kwame_a_headshot from "../../../assets/kwame_a_headshot.png";
import kwaku_a_headshot from "../../../assets/kwaku_a_headshot.png";
import yaw_a_headshot from "../../../assets/yaw_a_headshot.png";
import mensa_a_headshot from "../../../assets/mensa_a_headshot.png";
import kofi_a_pose1 from "../../../assets/kofi_a_pose1.png";
import kofi_a_pose2 from "../../../assets/kofi_a_pose2.png";
import kofi_a_pose3 from "../../../assets/Kofi_a_pose3.png";
import kofi_a_pose4 from "../../../assets/Kofi_a_pose4.png";
import kwame_a_pose1 from "../../../assets/kwame_a_pose1.png";
import kwame_a_pose2 from "../../../assets/kwame_a_pose2.png";
import kwame_a_pose3 from "../../../assets/kwame_a_pose3.png";
import kwame_a_pose4 from "../../../assets/kwame_a_pose4.png";
import yaw_a_pose1 from "../../../assets/yaw_a_pose1.png";
import yaw_a_pose2 from "../../../assets/yaw_a_pose2.png";
import yaw_a_pose3 from "../../../assets/yaw_a_pose3.png";
import yaw_a_pose4 from "../../../assets/yaw_a_pose4.png";
import mensa_a_pose1 from "../../../assets/mensa_a_pose1.png";
import mensa_a_pose2 from "../../../assets/mensa_a_pose2.png";
import mensa_a_pose3 from "../../../assets/mensa_a_pose3.png";
import mensa_a_pose4 from "../../../assets/mensa_a_pose4.png";
import kwaku_a_pose1 from "../../../assets/kwaku_a_pose1.png";
import kwaku_a_pose2 from "../../../assets/kwaku_a_pose2.png";
import kwaku_a_pose3 from "../../../assets/kwaku_a_pose3.png";
import kwaku_a_pose4 from "../../../assets/kwaku_a_pose4.png";
import jerry_headshot from "../../../assets/jerry_headshot.png";
import jerry_1 from "../../../assets/jerry_1.png";
import jerry_2 from "../../../assets/jerry_2.png";
import jerry_3 from "../../../assets/jerry_3.png";
import jerry_4 from "../../../assets/jerry_4.png";
import jerry_5 from "../../../assets/jerry_5.png";
import jimmy_headshot from "../../../assets/jimmy_headshot.png";
import jimmy_1 from "../../../assets/jimmy_1.png";
import jimmy_2 from "../../../assets/jimmy_2.png";
import jimmy_3 from "../../../assets/jimmy_3.png";
import jimmy_4 from "../../../assets/jimmy_4.png";
import jimmy_6 from "../../../assets/jimmy_6.png";
import remmy_headshot from "../../../assets/remmy_headshot.png";
import remmy_1 from "../../../assets/remmy_1.png";
import remmy_2 from "../../../assets/remmy_2.png";
import remmy_3 from "../../../assets/remmy_3.png";
import remmy_4 from "../../../assets/remmy_4.png";
import remmy_5 from "../../../assets/remmy_5.png";
import shadrack_headshot from "../../../assets/shadrack_headshot.png";
import shadrack_1 from "../../../assets/shadrack_1.png";
import shadrack_2 from "../../../assets/shadrack_2.png";
import shadrack_3 from "../../../assets/shadrack_3.png";
import shadrack_4 from "../../../assets/shadrack_4.png";
import shadrack_5 from "../../../assets/shadrack_5.png";
import thomas_headshot from "../../../assets/thomas_headshot.png";
import thomas_1 from "../../../assets/thomas_1.png";
import thomas_2 from "../../../assets/thomas_2.png";
import thomas_3 from "../../../assets/thomas_3.png";
import thomas_4 from "../../../assets/thomas_4.png";
import thomas_5 from "../../../assets/thomas_5.png";
import gusto_headshot from "../../../assets/gusto_headshot.png";
import gusto_1 from "../../../assets/gusto_1.png";
import gusto_2 from "../../../assets/gusto_2.png";
import gusto_3 from "../../../assets/gusto_3.png";
import gusto_4 from "../../../assets/gusto_4.png";
import gusto_5 from "../../../assets/gusto_5.png";
import jack_headshot from "../../../assets/jack_headshot.png";
import jack_1 from "../../../assets/jack_1.png";
import jack_2 from "../../../assets/jack_2.png";
import jack_3 from "../../../assets/jack_3.png";
import jack_4 from "../../../assets/jack_4.png";
import jack_5 from "../../../assets/jack_5.png";
import jon_headshot from "../../../assets/jon_headshot.png";
import jon_1 from "../../../assets/jon_1.png";
import jon_2 from "../../../assets/jon_2.png";
import jon_3 from "../../../assets/jon_3.png";
import jon_4 from "../../../assets/jon_4.png";
import jon_5 from "../../../assets/jon_5.png";
import micky_headshot from "../../../assets/micky_headshot.png";
import micky_1 from "../../../assets/micky_1.png";
import micky_2 from "../../../assets/micky_2.png";
import micky_3 from "../../../assets/micky_3.png";
import micky_4 from "../../../assets/micky_4.png";
import micky_5 from "../../../assets/micky_5.png";
import nesto_headshot from "../../../assets/nesto_headshot.png";
import nesto_1 from "../../../assets/nesto_1.png";
import nesto_2 from "../../../assets/nesto_2.png";
import nesto_3 from "../../../assets/nesto_3.png";
import nesto_4 from "../../../assets/nesto_4.png";
import nesto_5 from "../../../assets/nesto_5.png";
import zig_headshot from "../../../assets/zig_headshot.png";
import zig_1 from "../../../assets/zig_1.png";
import zig_2 from "../../../assets/zig_2.png";
import zig_3 from "../../../assets/zig_3.png";
import zig_4 from "../../../assets/zig_4.png";
import zig_5 from "../../../assets/zig_5.png";
import afia_a_headshot from "../../../assets/afia_a_headshot.png";
import akua_a_headshot from "../../../assets/akua_a_headshot.png";
import ama_a_headshot from "../../../assets/ama_a_headshot.png";
import abena_a_headshot from "../../../assets/abena_a_headshot.png";
import yaa_a_headshot from "../../../assets/yaa_a_headshot.png";
import afia_a_pose1 from "../../../assets/afia_a_pose1.png";
import afia_a_pose2 from "../../../assets/afia_a_pose2.png";
import afia_a_pose3 from "../../../assets/afia_a_pose3.png";
import afia_a_pose4 from "../../../assets/afia_a_pose4.png";
import akua_a_pose1 from "../../../assets/akua_a_pose1.png";
import akua_a_pose2 from "../../../assets/akua_a_pose2.png";
import akua_a_pose3 from "../../../assets/akua_a_pose3.png";
import akua_a_pose4 from "../../../assets/akua_a_pose4.png";
import ama_a_pose1 from "../../../assets/ama_a_pose1.png";
import ama_a_pose2 from "../../../assets/ama_a_pose2.png";
import ama_a_pose3 from "../../../assets/ama_a_pose3.png";
import ama_a_pose4 from "../../../assets/ama_a_pose4.png";
import abena_a_pose1 from "../../../assets/abena_a_pose1.png";
import abena_a_pose2 from "../../../assets/abena_a_pose2.png";
import abena_a_pose3 from "../../../assets/abena_a_pose3.png";
import abena_a_pose4 from "../../../assets/abena_a_pose4.png";
import yaa_a_pose1 from "../../../assets/yaa_a_pose1.png";
import yaa_a_pose2 from "../../../assets/yaa_a_pose2.png";
import yaa_a_pose3 from "../../../assets/yaa_a_pose3.png";
import yaa_a_pose4 from "../../../assets/yaa_a_pose4.png";
import celine_headshot from "../../../assets/celine_headshot.png";
import celine_1 from "../../../assets/celine_1.png";
import celine_2 from "../../../assets/celine_2.png";
import celine_3 from "../../../assets/celine_3.png";
import celine_4 from "../../../assets/celine_4.png";
import celine_5 from "../../../assets/celine_5.png";
import cindy_headshot from "../../../assets/cindy_headshot.png";
import cindy_1 from "../../../assets/cindy_1.png";
import cindy_2 from "../../../assets/cindy_2.png";
import cindy_3 from "../../../assets/cindy_3.png";
import cindy_4 from "../../../assets/cindy_4.png";
import cindy_5 from "../../../assets/cindy_5.png";
import latifa_headshot from "../../../assets/latifa_headshot.png";
import latifa_1 from "../../../assets/latifa_1.png";
import latifa_2 from "../../../assets/latifa_2.png";
import latifa_3 from "../../../assets/latifa_3.png";
import latifa_4 from "../../../assets/latifa_4.png";
import latifa_5 from "../../../assets/latifa_5.png";
import nicki_headshot from "../../../assets/nicki_headshot.png";
import nicki_1 from "../../../assets/nicki_1.png";
import nicki_2 from "../../../assets/nicki_2.png";
import nicki_3 from "../../../assets/nicki_3.png";
import nicki_4 from "../../../assets/nicki_4.png";
import nicki_5 from "../../../assets/nicki_5.png";
import rakiya_headshot from "../../../assets/rakiya_headshot.png";
import rakiya_1 from "../../../assets/rakiya_1.png";
import rakiya_2 from "../../../assets/rakiya_2.png";
import rakiya_3 from "../../../assets/rakiya_3.png";
import rakiya_4 from "../../../assets/rakiya_4.png";
import rakiya_5 from "../../../assets/rakiya_5.png";
import aisha_headshot from "../../../assets/aisha_headshot.png";
import aisha_1 from "../../../assets/aisha_1.png";
import aisha_2 from "../../../assets/aisha_2.png";
import aisha_3 from "../../../assets/aisha_3.png";
import aisha_4 from "../../../assets/aisha_4.png";
import aisha_5 from "../../../assets/aisha_5.png";
import gina_headshot from "../../../assets/gina_headshot.png";
import gina_1 from "../../../assets/gina_1.png";
import gina_2 from "../../../assets/gina_2.png";
import gina_3 from "../../../assets/gina_3.png";
import gina_4 from "../../../assets/gina_4.png";
import gina_5 from "../../../assets/gina_5.png";
import peggy_headshot from "../../../assets/peggy_headshot.png";
import peggy_1 from "../../../assets/peggy_1.png";
import peggy_2 from "../../../assets/peggy_2.png";
import peggy_3 from "../../../assets/peggy_3.png";
import peggy_4 from "../../../assets/peggy_4.png";
import peggy_5 from "../../../assets/peggy_5.png";
import vicky_headshot from "../../../assets/vicky_headshot.png";
import vicky_1 from "../../../assets/vicky_1.png";
import vicky_2 from "../../../assets/vicky_2.png";
import vicky_3 from "../../../assets/vicky_3.png";
import vicky_4 from "../../../assets/vicky_4.png";
import vicky_5 from "../../../assets/vicky_5.png";
import ada_headshot from "../../../assets/ada_headshot.png";
import ada_1 from "../../../assets/ada_1.png";
import ada_2 from "../../../assets/ada_2.jpg";
import ada_3 from "../../../assets/ada_3.png";
import ada_4 from "../../../assets/ada_4.png";
import ada_5 from "../../../assets/ada_5.png";
import angela_headshot from "../../../assets/angela_headshot.png";
import angela_1 from "../../../assets/angela_1.png";
import angela_2 from "../../../assets/angela_2.png";
import angela_3 from "../../../assets/angela_3.png";
import angela_4 from "../../../assets/angela_4.png";
import angela_5 from "../../../assets/angela_5.png";
import camsy_headshot from "../../../assets/camsy_headshot.png";
import camsy_1 from "../../../assets/camsy_1.png";
import camsy_2 from "../../../assets/camsy_2.png";
import camsy_3 from "../../../assets/camsy_3.png";
import camsy_4 from "../../../assets/camsy_4.png";
import camsy_5 from "../../../assets/camsy_5.png";
import maud_headshot from "../../../assets/maud_headshot.png";
import maud_1 from "../../../assets/maud_1.png";
import maud_2 from "../../../assets/maud_2.png";
import maud_3 from "../../../assets/maud_3.png";
import maud_4 from "../../../assets/maud_4.png";
import maud_5 from "../../../assets/maud_5.png";
import philis_headshot from "../../../assets/philis_headshot.png";
import philis_1 from "../../../assets/philis_1.png";
import philis_2 from "../../../assets/philis_2.png";
import philis_3 from "../../../assets/philis_3.png";
import philis_4 from "../../../assets/philis_4.png";
import philis_5 from "../../../assets/philis_5.png";
import precious_headshot from "../../../assets/precious_headshot.png";
import precious_1 from "../../../assets/precious_1.png";
import precious_2 from "../../../assets/precious_2.png";
import precious_3 from "../../../assets/precious_3.png";
import precious_4 from "../../../assets/precious_4.png";
import precious_5 from "../../../assets/precious_5.png";
import bg_image1 from "../../../assets/bg_image1.png";
import bg_image2 from "../../../assets/bg_image2.png";
import bg_image3 from "../../../assets/bg_image3.png";
import bg_image4 from "../../../assets/bg_image4.png";
import bg_image5 from "../../../assets/bg_image5.png";
import bg_image6 from "../../../assets/bg_image6.png";
import bg_image7 from "../../../assets/bg_image7.png";
import bg_image8 from "../../../assets/bg_image8.png";
 import bg_image9 from "../../../assets/bg_image9.png";
 import bg_image10 from "../../../assets/bg_image10.png";
// import bg_image11 from "../../../assets/bg_image11.png";
 import bg_image12 from "../../../assets/bg_image12.png";

export const maleModels = [
  {id: "kofi_a", image: kofi_a_headshot, plan:"all"},
  {id: "kwame_a", image: kwame_a_headshot, plan: "all"},
  {id: "kwaku_a", image: kwaku_a_headshot, plan: "all"},
  {id: "yaw_a", image: yaw_a_headshot, plan: "all"},
  {id: "mensa_a", image: mensa_a_headshot, plan: "all"},
  {id: "jerry", image: jerry_headshot, plan: "all"},
  {id: "jimmy", image: jimmy_headshot, plan: "all"},
  {id: "remmy", image: remmy_headshot, plan: "all"},
  {id: "shadrack", image: shadrack_headshot, plan: "all"},
  {id: "thomas", image: thomas_headshot, plan: "all"},
  {id: "gusto", image: gusto_headshot, plan: "all"},
  {id: "jack", image: jack_headshot, plan: "all"},
  {id: "jon", image: jon_headshot, plan: "all"},
  {id: "micky", image: micky_headshot, plan: "all"},
  {id: "nesto", image: nesto_headshot, plan: "all"},
  {id: "zig", image: zig_headshot, plan: "all"}
];

export const femaleModels = [
  {id: "afia_a", image: afia_a_headshot, plan: "all"},
  {id: "akua_a", image: akua_a_headshot, plan: "all"},
  {id: "ama_a", image: ama_a_headshot, plan: "all"},
  {id: "abena_a", image: abena_a_headshot, plan: "all"},
  {id: "yaa_a", image: yaa_a_headshot, plan: "all"},
  {id: "celine", image: celine_headshot, plan: "all"},
  {id: "cindy", image: cindy_headshot, plan: "all"},
  {id: "latifa", image: latifa_headshot, plan: "all"},
  {id: "nicki", image: nicki_headshot, plan: "all"},
  {id: "rakiya", image: rakiya_headshot, plan: "all"},
  {id: "aisha", image: aisha_headshot, plan: "all"},
  {id: "gina", image: gina_headshot, plan: "all"},
  {id: "peggy", image: peggy_headshot, plan: "all"},
  {id: "vicky", image: vicky_headshot, plan: "all"},
  {id: "ada", image: ada_headshot, plan: "all"},
  {id: "angela", image: angela_headshot, plan: "all"},
  {id: "camsy", image: camsy_headshot, plan: "all"},
  {id: "maud", image: maud_headshot, plan: "all"},
  {id: "philis", image: philis_headshot, plan: "all"},
  {id: "precious", image: precious_headshot, plan: "all"}
];

export const posesImages = [
  { id: "kofi_a_pose1", image: kofi_a_pose1, plan:"all" },
  { id: "kofi_a_pose2", image: kofi_a_pose2, plan:"all" },
  { id: "kofi_a_pose3", image: kofi_a_pose3, plan:"all" },
  { id: "kofi_a_pose4", image: kofi_a_pose4, plan:"all" },
  { id: "kwame_a_pose1", image: kwame_a_pose1, plan: "all" },
  { id: "kwame_a_pose2", image: kwame_a_pose2, plan: "all" },
  { id: "kwame_a_pose3", image: kwame_a_pose3, plan: "all" },
  { id: "kwame_a_pose4", image: kwame_a_pose4, plan: "all" },
  { id: "kwaku_a_pose1", image: kwaku_a_pose1, plan: "all" },
  { id: "kwaku_a_pose2", image: kwaku_a_pose2, plan: "all" },
  { id: "kwaku_a_pose3", image: kwaku_a_pose3, plan: "all" },
  { id: "kwaku_a_pose4", image: kwaku_a_pose4, plan: "all" },
  { id: "yaw_a_pose1", image: yaw_a_pose1, plan: "all" },
  { id: "yaw_a_pose2", image: yaw_a_pose2, plan: "all" },
  { id: "yaw_a_pose3", image: yaw_a_pose3, plan: "all" },
  { id: "yaw_a_pose4", image: yaw_a_pose4, plan: "all" },
  { id: "mensa_a_pose1", image: mensa_a_pose1, plan: "all" },
  { id: "mensa_a_pose2", image: mensa_a_pose2, plan: "all" },
  { id: "mensa_a_pose3", image: mensa_a_pose3, plan: "all" },
  { id: "mensa_a_pose4", image: mensa_a_pose4, plan: "all" },
  { id: "jerry_1", image: jerry_1, plan: "all" },
  { id: "jerry_2", image: jerry_2, plan: "all" },
  { id: "jerry_3", image: jerry_3, plan: "all" },
  { id: "jerry_4", image: jerry_4, plan: "all" },
  { id: "jerry_5", image: jerry_5, plan: "all" },
  { id: "jimmy_1", image: jimmy_1, plan: "all" },
  { id: "jimmy_2", image: jimmy_2, plan: "all" },
  { id: "jimmy_3", image: jimmy_3, plan: "all" },
  { id: "jimmy_4", image: jimmy_4, plan: "all" },
  { id: "jimmy_6", image: jimmy_6, plan: "all" },
  { id: "remmy_1", image: remmy_1, plan: "all" },
  { id: "remmy_2", image: remmy_2, plan: "all" },
  { id: "remmy_3", image: remmy_3, plan: "all" },
  { id: "remmy_4", image: remmy_4, plan: "all" },
  { id: "remmy_5", image: remmy_5, plan: "all" },
  { id: "shadrack_1", image: shadrack_1, plan: "all" },
  { id: "shadrack_2", image: shadrack_2, plan: "all" },
  { id: "shadrack_3", image: shadrack_3, plan: "all" },
  { id: "shadrack_4", image: shadrack_4, plan: "all" },
  { id: "shadrack_5", image: shadrack_5, plan: "all" },
  { id: "thomas_1", image: thomas_1, plan: "all" },
  { id: "thomas_2", image: thomas_2, plan: "all" },
  { id: "thomas_3", image: thomas_3, plan: "all" },
  { id: "thomas_4", image: thomas_4, plan: "all" },
  { id: "thomas_5", image: thomas_5, plan: "all" },
  { id: "gusto_1", image: gusto_1, plan: "all" },
  { id: "gusto_2", image: gusto_2, plan: "all" },
  { id: "gusto_3", image: gusto_3, plan: "all" },
  { id: "gusto_4", image: gusto_4, plan: "all" },
  { id: "gusto_5", image: gusto_5, plan: "all" },
  { id: "jack_1", image: jack_1, plan: "all" },
  { id: "jack_2", image: jack_2, plan: "all" },
  { id: "jack_3", image: jack_3, plan: "all" },
  { id: "jack_4", image: jack_4, plan: "all" },
  { id: "jack_5", image: jack_5, plan: "all" },
  { id: "jon_1", image: jon_1, plan: "all" },
  { id: "jon_2", image: jon_2, plan: "all" },
  { id: "jon_3", image: jon_3, plan: "all" },
  { id: "jon_4", image: jon_4, plan: "all" },
  { id: "jon_5", image: jon_5, plan: "all" },
  { id: "micky_1", image: micky_1, plan: "all" },
  { id: "micky_2", image: micky_2, plan: "all" },
  { id: "micky_3", image: micky_3, plan: "all" },
  { id: "micky_4", image: micky_4, plan: "all" },
  { id: "micky_5", image: micky_5, plan: "all" },
  { id: "nesto_1", image: nesto_1, plan: "all" },
  { id: "nesto_2", image: nesto_2, plan: "all" },
  { id: "nesto_3", image: nesto_3, plan: "all" },
  { id: "nesto_4", image: nesto_4, plan: "all" },
  { id: "nesto_5", image: nesto_5, plan: "all" },
  { id: "zig_1", image: zig_1, plan: "all" },
  { id: "zig_2", image: zig_2, plan: "all" },
  { id: "zig_3", image: zig_3, plan: "all" },
  { id: "zig_4", image: zig_4, plan: "all" },
  { id: "zig_5", image: zig_5, plan: "all" },
  { id: "afia_a_pose1", image: afia_a_pose1, plan: "all" },
  { id: "afia_a_pose2", image: afia_a_pose2, plan: "all" },
  { id: "afia_a_pose3", image: afia_a_pose3, plan: "all" },
  { id: "afia_a_pose4", image: afia_a_pose4, plan: "all" },
  { id: "akua_a_pose1", image: akua_a_pose1, plan: "all" },
  { id: "akua_a_pose2", image: akua_a_pose2, plan: "all" },
  { id: "akua_a_pose3", image: akua_a_pose3, plan: "all" },
  { id: "akua_a_pose4", image: akua_a_pose4, plan: "all" },
  { id: "ama_a_pose1", image: ama_a_pose1, plan: "all" },
  { id: "ama_a_pose2", image: ama_a_pose2, plan: "all" },
  { id: "ama_a_pose3", image: ama_a_pose3, plan: "all" },
  { id: "ama_a_pose4", image: ama_a_pose4, plan: "all" },
  { id: "abena_a_pose1", image: abena_a_pose1, plan: "all" },
  { id: "abena_a_pose2", image: abena_a_pose2, plan: "all" },
  { id: "abena_a_pose3", image: abena_a_pose3, plan: "all" },
  { id: "abena_a_pose4", image: abena_a_pose4, plan: "all" },
  { id: "yaa_a_pose1", image: yaa_a_pose1, plan: "all" },
  { id: "yaa_a_pose2", image: yaa_a_pose2, plan: "all" },
  { id: "yaa_a_pose3", image: yaa_a_pose3, plan: "all" },
  { id: "yaa_a_pose4", image: yaa_a_pose4, plan: "all" },
  { id: "celine_1", image: celine_1, plan: "all" },
  { id: "celine_2", image: celine_2, plan: "all" },
  { id: "celine_3", image: celine_3, plan: "all" },
  { id: "celine_4", image: celine_4, plan: "all" },
  { id: "celine_5", image: celine_5, plan: "all" },
  { id: "cindy_1", image: cindy_1, plan: "all" },
  { id: "cindy_2", image: cindy_2, plan: "all" },
  { id: "cindy_3", image: cindy_3, plan: "all" },
  { id: "cindy_4", image: cindy_4, plan: "all" },
  { id: "cindy_5", image: cindy_5, plan: "all" },
  { id: "latifa_1", image: latifa_1, plan: "all" },
  { id: "latifa_2", image: latifa_2, plan: "all" },
  { id: "latifa_3", image: latifa_3, plan: "all" },
  { id: "latifa_4", image: latifa_4, plan: "all" },
  { id: "latifa_5", image: latifa_5, plan: "all" },
  { id: "nicki_1", image: nicki_1, plan: "all" },
  { id: "nicki_2", image: nicki_2, plan: "all" },
  { id: "nicki_3", image: nicki_3, plan: "all" },
  { id: "nicki_4", image: nicki_4, plan: "all" },
  { id: "nicki_5", image: nicki_5, plan: "all" },
  { id: "rakiya_1", image: rakiya_1, plan: "all" },
  { id: "rakiya_2", image: rakiya_2, plan: "all" },
  { id: "rakiya_3", image: rakiya_3, plan: "all" },
  { id: "rakiya_4", image: rakiya_4, plan: "all" },
  { id: "rakiya_5", image: rakiya_5, plan: "all" },
  { id: "aisha_1", image: aisha_1, plan: "all" },
  { id: "aisha_2", image: aisha_2, plan: "all" },
  { id: "aisha_3", image: aisha_3, plan: "all" },
  { id: "aisha_4", image: aisha_4, plan: "all" },
  { id: "aisha_5", image: aisha_5, plan: "all" },
  { id: "gina_1", image: gina_1, plan: "all" },
  { id: "gina_2", image: gina_2, plan: "all" },
  { id: "gina_3", image: gina_3, plan: "all" },
  { id: "gina_4", image: gina_4, plan: "all" },
  { id: "gina_5", image: gina_5, plan: "all" },
  { id: "peggy_1", image: peggy_1, plan: "all" },
  { id: "peggy_2", image: peggy_2, plan: "all" },
  { id: "peggy_3", image: peggy_3, plan: "all" },
  { id: "peggy_4", image: peggy_4, plan: "all" },
  { id: "peggy_5", image: peggy_5, plan: "all" },
  { id: "vicky_1", image: vicky_1, plan: "all" },
  { id: "vicky_2", image: vicky_2, plan: "all" },
  { id: "vicky_3", image: vicky_3, plan: "all" },
  { id: "vicky_4", image: vicky_4, plan: "all" },
  { id: "vicky_5", image: vicky_5, plan: "all" },
  { id: "ada_1", image: ada_1, plan: "all" },
  { id: "ada_2", image: ada_2, plan: "all" },
  { id: "ada_3", image: ada_3, plan: "all" },
  { id: "ada_4", image: ada_4, plan: "all" },
  { id: "ada_5", image: ada_5, plan: "all" },
  { id: "angela_1", image: angela_1, plan: "all" },
  { id: "angela_2", image: angela_2, plan: "all" },
  { id: "angela_3", image: angela_3, plan: "all" },
  { id: "angela_4", image: angela_4, plan: "all" },
  { id: "angela_5", image: angela_5, plan: "all" },
  { id: "camsy_1", image: camsy_1, plan: "all" },
  { id: "camsy_2", image: camsy_2, plan: "all" },
  { id: "camsy_3", image: camsy_3, plan: "all" },
  { id: "camsy_4", image: camsy_4, plan: "all" },
  { id: "camsy_5", image: camsy_5, plan: "all" },
  { id: "maud_1", image: maud_1, plan: "all" },
  { id: "maud_2", image: maud_2, plan: "all" },
  { id: "maud_3", image: maud_3, plan: "all" },
  { id: "maud_4", image: maud_4, plan: "all" },
  { id: "maud_5", image: maud_5, plan: "all" },
  { id: "philis_1", image: philis_1, plan: "all" },
  { id: "philis_2", image: philis_2, plan: "all" },
  { id: "philis_3", image: philis_3, plan: "all" },
  { id: "philis_4", image: philis_4, plan: "all" },
  { id: "philis_5", image: philis_5, plan: "all" },
  { id: "precious_1", image: precious_1, plan: "all" },
  { id: "precious_2", image: precious_2, plan: "all" },
  { id: "precious_3", image: precious_3, plan: "all" },
  { id: "precious_4", image: precious_4, plan: "all" },
  { id: "precious_5", image: precious_5, plan: "all" }
];

export const backgroundImages = [
  bg_image1,
  bg_image2,
  bg_image3,
  bg_image4,
  bg_image5,
  bg_image6,
  bg_image7,
  bg_image8,
   bg_image9,
   bg_image10,
  // bg_image11,
   bg_image12
];